import { useTranslation } from "react-i18next";
import CoolnetPageLayout from "./components/CoolnetPageLayout";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import { coolnetPrecisionAC } from "@/mocks/coolnet";

export default function PrecisionACPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Aire Acondicionado de Precision Coolnet | Ventra Core Mexico"
        description="Aire acondicionado de precision Coolnet para centros de datos y salas de informatica. Series Cool-Row, CMF y CJA. Distribuidor autorizado en Mexico."
        keywords="aire acondicionado precision, Coolnet PAC, climatizacion centros de datos, enfriamiento servidores, serie Cool-Row, bomba fluoruro, Leon Mexico"
        canonical="https://ventracore.com.mx/coolnet/aire-acondicionado-precision"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "@id": "https://ventracore.com.mx/coolnet/aire-acondicionado-precision#product",
            "name": "Aire Acondicionado de Precision Coolnet",
            "brand": {
              "@type": "Brand",
              "name": "Coolnet",
            },
            "description": "Aire acondicionado de precision para centros de datos y salas de informatica.",
            "offers": {
              "@type": "AggregateOffer",
              "availability": "https://schema.org/InStock",
              "priceCurrency": "MXN",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Coolnet",
                "item": "https://ventracore.com.mx/coolnet",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Aire Acondicionado de Precision",
                "item": "https://ventracore.com.mx/coolnet/aire-acondicionado-precision",
              },
            ],
          },
        ]}
      />
      <CoolnetPageLayout
        title={t("coolnetPage.pac.title")}
        subtitle={t("coolnetPage.pac.subtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify mb-10">
            {coolnetPrecisionAC.intro}
          </p>

          <h3 className="text-xl md:text-2xl font-bold text-magenta mb-8 uppercase tracking-wide">
            {t("coolnetPage.pac.productsTitle")}
          </h3>

          <div className="space-y-10">
            {coolnetPrecisionAC.products.map((product, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } items-center gap-6 lg:gap-10`}
              >
                <div className="w-full lg:w-1/2 h-56 md:h-72 overflow-hidden rounded-lg">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full lg:w-1/2">
                  <h4 className="text-lg md:text-xl font-bold text-brandgreen mb-3">
                    {product.title}
                  </h4>
                  <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-text-muted">
              {coolnetPrecisionAC.contact}
            </p>
          </div>
        </div>
      </CoolnetPageLayout>
    </Layout>
  );
}